<script lang="ts" setup>
import { useServicesStore } from "~/stores/services";
import { computed } from 'vue'

const servicesStore: any = useServicesStore();

const serviceList = servicesStore.hardcodeServices
</script>
<template>
  <div class="container text-body bg-white mt-2 rounded rounded-4 px-3 pb-3">
    <div class="container pt-3">
      <div class="row d-flex-sm py-3">
        <div class="col-4 col-12-sm text-center px-0">
          <NuxtLink to="/produk-digital/pulsa-data" class="text-warning" style="text-decoration: none;">
            <div class="row border rounded rounded-4 pb-4 m-2">
              <i class="fa-solid fa-mobile-screen fa-2xl mt-5"></i>
              <br />
              <label style="cursor: pointer" class="fw-semibold mt-3" for=""
                >Pulsa & Paket Data</label
              >
            </div>
          </NuxtLink>
        </div>
        <div
          v-for="service in serviceList"
          :key="service.id"
          class="col-4 col-12-sm  text-center px-0"
        >
          <NuxtLink
            :to="{
              path: service.url,
            }"
            class="text-warning"
            style="text-decoration: none;"
          >
            <div class="row border rounded rounded-4 pb-4 m-2">
              <i :class="service.iconClass + ' fa-2xl mt-5'"></i>
              <br />
              <label style="cursor: pointer" class="fw-semibold mt-3">{{
                service.label
              }}</label>
            </div>
          </NuxtLink>
        </div>
  
        <div class="col-4  col-12-sm text-center px-0">
          <NuxtLink to="produk-digital/e-money" class="text-warning"  style="text-decoration: none;">
            <div class="row border rounded rounded-4 pb-4 m-2">
              <i class="fa-solid fa-credit-card fa-2xl mt-5"></i>
              <br />
              <label style="cursor: pointer" class="fw-semibold mt-3" for=""
                >Uang Elektronik</label
              >
            </div>
          </NuxtLink>
        </div>
        <div class="col-4  col-12-sm text-center px-0">
          <NuxtLink to="produk-digital/e-wallet" class="text-warning" style="text-decoration: none;">
            <div class="row border rounded rounded-4 pb-4 m-2">
              <i class="fa-solid fa-wallet fa-2xl mt-5"></i>
              <br />
              <label style="cursor: pointer" class="fw-semibold mt-3" for=""
                >Dompet Elektronik</label
              >
            </div>
          </NuxtLink>
        </div>
        <div class="col-4  col-12-sm text-center px-0">
          <NuxtLink to="produk-digital/games" class="text-warning" style="text-decoration: none;">
            <div class="row border rounded rounded-4 pb-4 m-2">
              <i class="fa-solid fa-gamepad fa-2xl mt-5"></i>
              <br />
              <label style="cursor: pointer" class="fw-semibold mt-3" for=""
                >Games</label
              >
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>